import {
  Form1099Status,
  ICollaboratorSchema,
  MemberClientTaxStatus
} from "@wingspanhq/payments/dist/interfaces";

const getAvailableStatusOptions = (
  collaborator: ICollaboratorSchema,
  status: Form1099Status | undefined
): Form1099Status[] => {
  switch (status) {
    case Form1099Status.Ready:
      return [Form1099Status.Ready, Form1099Status.Excluded];

    case Form1099Status.Rejected:
      return [Form1099Status.Rejected, Form1099Status.Excluded];

    case Form1099Status.NeedsActionDispute:
    case Form1099Status.NeedsActionInfo:
      return [
        Form1099Status.NeedsActionInfo,
        Form1099Status.Excluded,
        Form1099Status.Ready
      ];

    case Form1099Status.Excluded:
      return collaborator.taxStatus === MemberClientTaxStatus.Complete
        ? [Form1099Status.Excluded, Form1099Status.Ready]
        : [Form1099Status.Excluded, Form1099Status.NeedsActionInfo];

    default:
      return [];
  }
};

export default getAvailableStatusOptions;
